import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { FindLoad } from 'utils';
import { dashboardActions } from 'store';
import { getDaysLabel } from './constants';

const ACTION_TYPE = 'GET_DASHBOARD_EXPIRING_AUTHS';

// At most one decimal, and none on whole numbers: 12 → "12", 12.25 → "12.3".
const formatUnits = (units) => Number(units.toFixed(1)).toString();

export const ExpiringAuthorizationsCard = ({ item, handleDeleteWidget }) => {
    const dispatch = useDispatch();
    const { expiringAuthorizations } = useSelector((state) => ({
        expiringAuthorizations: state.dashboard.expiringAuthorizations,
    }));
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    const authorizations = expiringAuthorizations?.authorizations || [];

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell iconId={10} onClose={handleDeleteWidget}>
            <div className="main-dashboard-card-body">
                {authorizations.length ? (
                    <div className="expiring-auth-list">
                        {authorizations.map((auth, index) => {
                            const showUsage = typeof auth?.usedUnits === 'number' && auth?.totalUnits > 0;
                            const usagePercent = showUsage ? Math.max(0, Math.min(100, (auth.usedUnits / auth.totalUnits) * 100)) : 0;

                            return (
                                <div className="expiring-auth-row" key={index}>
                                    <div className="expiring-auth-row__head">
                                        <div className="expiring-auth-row__info">
                                            <p className="expiring-auth-row__name">
                                                {auth?.clientName}
                                                {auth?.clientCode ? ` (${auth?.clientCode})` : ''}
                                            </p>
                                            {auth?.payerName && <p className="expiring-auth-row__payer">{auth?.payerName}</p>}
                                        </div>
                                        <span className="expiring-auth-row__days">{getDaysLabel(auth?.daysRemaining)}</span>
                                    </div>

                                    {showUsage && (
                                        <div className="expiring-auth-row__usage">
                                            <div className="expiring-auth-row__bar">
                                                <span className="expiring-auth-row__fill" style={{ width: `${usagePercent}%` }} />
                                            </div>
                                            <span className="expiring-auth-row__units">
                                                {formatUnits(auth.usedUnits)}/{formatUnits(auth.totalUnits)} units
                                            </span>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <EmptyStateDashboard iconId={10} title="All Clear!" description={'No authorizations expiring soon'} />
                )}
            </div>
        </DashboardWidgetShell>
    );
};
